export function formatCHF(amount: number): string {
  return `CHF ${amount.toFixed(2)}`;
}
